import { BBTreeviewNode, CheckboxNode, DateNode } from '../../types'

export function isCheckboxNode(node: BBTreeviewNode): node is CheckboxNode {
  return node.type === 'Checkbox'
}

export function isDateNode(node: BBTreeviewNode): node is DateNode {
  return node.type === 'Date'
}
